import { useSelector } from 'react-redux';

import { getUserAgent } from 'src/modules/chalice-user-agent/isomorphic-useragent';
import {
  selectFeatureFlag,
  selectIsJobDetailsPending,
  selectSelectedJobId,
  selectIsJobDetailsFetchFailure,
  selectJobDetailsIsExpired,
  selectXRealIp,
} from 'src/store/selectors';

const useJobDetail = () => {
  const autoSelectSplitViewFirstJob = useSelector(
    selectFeatureFlag('autoSelectSplitViewFirstJob'),
  );
  const isLoading = useSelector(selectIsJobDetailsPending);
  const isError = useSelector(selectIsJobDetailsFetchFailure);
  const isExpired = useSelector(selectJobDetailsIsExpired);
  const hasJobId = Boolean(useSelector(selectSelectedJobId));
  const ipAddress = useSelector(selectXRealIp);
  const userAgent = getUserAgent();

  return {
    isLoading,
    isError,
    isExpired,
    hasJobId,
    autoSelectSplitViewFirstJob,
    ipAddress,
    userAgent,
  };
};

export default useJobDetail;
